import LangEnum from '../../../../lang/LangEnum';
import { UsedInOfflineMode } from '../../../offline/types/UsedInOfflineMode';
import {
  ListSortViewEnum,
  ModalLayoutEnum,
  OrderHeadersGroupByEnum,
  OrderHeadersGroupByInfo,
} from '../orderProducts.types';

export type OptionType = {
  label: LangEnum;
  value: OrderHeadersGroupByEnum | ListSortViewEnum | ModalLayoutEnum;
  extraInfo?: OrderHeadersGroupByInfo;
  disabled?: boolean;
};

export interface Options {
  groupBy: OptionType[];
  sortBy: OptionType[];
  layout?: OptionType[];
}

interface GetDefaultOptions extends UsedInOfflineMode {
  isOrderEditPage: boolean;
  withImageOptions?: boolean;
}

export const getDefaultOptions = ({
  isOrderEditPage,
  isOfflineMode,
  withImageOptions = false,
}: GetDefaultOptions): Options => {
  const defaultOptions: Options = {
    groupBy: [
      {
        label: LangEnum.ORDER_PRODUCTS_GROUPY_BY_NONE_LABEL,
        value: OrderHeadersGroupByEnum.DEFAULT,
      },
      {
        label: LangEnum.ORDER_PRODUCTS_GROUPY_BY_DELIVERY_LABEL,
        value: OrderHeadersGroupByEnum.DELIVERY_WINDOW,
      },
      {
        label: LangEnum.ORDER_PRODUCTS_GROUPY_BY_COLLECTION_LABEL,
        value: OrderHeadersGroupByEnum.COLLECTION,
      },
      {
        label: LangEnum.ORDER_PRODUCTS_GROUPY_BY_CATEGORY_LABEL,
        value: OrderHeadersGroupByEnum.CATEGORY,
      },
      {
        label: LangEnum.ORDER_PRODUCTS_GROUP_BY_SUBCATEGORY_LABEL,
        value: OrderHeadersGroupByEnum.SUB_CATEGORY,
      },
      {
        label: LangEnum.ORDER_PRODUCTS_GROUPY_BY_PRODUCT_LABEL,
        value: OrderHeadersGroupByEnum.PRODUCT,
      },
    ],
    sortBy: [
      {
        label: LangEnum.ORDER_PRODUCTS_SORT_BY_CODE_LABEL,
        value: ListSortViewEnum.CODE,
      },
      {
        label: LangEnum.ORDER_PRODUCTS_SORT_BY_A_TO_Z_LABEL,
        value: ListSortViewEnum.PRODUCT_NAME_A_Z,
      },
      {
        label: LangEnum.ORDER_PRODUCTS_SORT_BY_REFERENCE_CODE_LABEL,
        value: ListSortViewEnum.REFERENCE_CODE,
      },
      {
        label: LangEnum.ORDER_PRODUCTS_SORT_BY_LAST_ADDED_LABEL,
        value: ListSortViewEnum.LAST_ADDED,
      },
    ],
  };

  if (isOrderEditPage && !isOfflineMode) {
    defaultOptions.groupBy.push({
      label: LangEnum.ORDER_PRODUCTS_GROUPY_BY_PENDENCY_LABEL,
      value: OrderHeadersGroupByEnum.PENDENCY,
    });
  }

  if (withImageOptions) {
    defaultOptions.layout = [
      {
        label: LangEnum.ORDER_PRODUCTS_LAYOUT_WITH_IMAGE,
        value: ModalLayoutEnum.LIST_WITH_PICTURES,
      },
      {
        label: LangEnum.ORDER_PRODUCTS_LAYOUT_WITHOUT_IMAGE,
        value: ModalLayoutEnum.LIST_NO_PICTURES,
      },
    ];
  }

  return defaultOptions;
};
